export default __webpack_public_path__ + "static/biologia_ug-0228e340656ab499224e91bd530065ca.png";